<template lang="pug">
    re-modal.send-tip-modal(container-class="re-modal-sm" @close="$emit('close')")
        .re-modal-title Send tip
        .re-modal-content
            creator-control(:creator="user")
            re-input(v-model="tipAmount")
        .re-modal-buttons
            re-button.re-button--primary.re-button--sm(@click="sendTip") Send

</template>

<script>
import UserProductsService from '../../services/user-products-service'

export default {
    name: 'send-tip-modal',

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() { return {
        tipAmount: 0,
    }},

    methods: {
        async sendTip() {
            const product = await UserProductsService.firstOfType(this.user.id, 'creator_tip')

            this.$store.dispatch('Shop/Orders/Cart/addCartItem', {
                id: `tip_${this.user.id}_via_${product.id}`,
                type: 'tip',
                payload: {
                    product_id: product.id,
                    options: {
                        amount: this.tipAmount,
                    },
                },
                attributes: {
                    product: product,
                },
                total: this.tipAmount,
            })

            this.$router.push({ name: 'shopping-cart-page' })
        },
    },
}
</script>

<style lang="scss" scoped>
.send-tip-modal {
    .creator-control {
        margin-bottom: 24px;
    }
}
</style>
